import React from "react"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import TextField from "material-ui/TextField"
import AppStateStore from "../../../../stores/AppStateStore"

const moment = require("moment")

export default class AuthorizationDocSelectField extends React.Component {
    constructor(props) {
        super()
        this.state = {
            value: 0
        }

        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event, index, value) {}

    render() {
        const labelArray = [
            "Certification of Birth Abroad issued by the Department of State",
            "Certification of Report of Birth issued by the Department of State",
            "Native American tribal document",
            "Identification Card for Use of Resident Citizen in the United States",
            "Employment Authorization ducment issued by DHS"
        ]

        const valueArray = [0, 1, 2, 3, 4]

        return (
            <div className="AuthorizationDocSelectField" style={{ marginTop: 20, marginBottom: 20, textAlign: "left" }}>
                <div style={{ color: "#cccccc", marginBottom: 10, fontSize: 12 }}>Identity Document List</div>
                <select
                    value={this.state.value}
                    onChange={this.handleChange}
                    style={{
                        width: "100%",
                        fontSize: "16px",
                        marginRight: 10,
                        border: "none",
                        borderBottom: "solid 1px #e1e1e1"
                    }}
                >
                    {labelArray.map(function(value, i) {
                        return (
                            <option value={valueArray[i]} key={i}>
                                {value}
                            </option>
                        )
                    })}
                </select>
            </div>
        )
    }
}
